import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import api from '../services/api';

import {
  IconeCle, IconeHorloge,
} from '../components/IconesSVG';

const LONGUEUR_MINIMALE = 8;

export default function ChangerMotDePassePage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthStore();
  const [form, setForm] = useState({ ancien: '', nouveau: '', confirmation: '' });
  const [erreur, setErreur] = useState('');
  const [succes, setSucces] = useState('');
  const [enCours, setEnCours] = useState(false);

  // Un compte reinitialise par un administrateur ne peut rien faire d'autre :
  // pas de bouton retour, pas de navigation laterale.
  const impose = !!user?.changer_mot_de_passe_requis;

  const modifier = (champ) => (e) => setForm({ ...form, [champ]: e.target.value });

  const valider = () => {
    if (!form.ancien) return 'Saisissez votre mot de passe actuel';
    if (form.nouveau.length < LONGUEUR_MINIMALE) {
      return `Le nouveau mot de passe doit faire au moins ${LONGUEUR_MINIMALE} caractères`;
    }
    if (form.nouveau !== form.confirmation) return 'Les deux saisies ne correspondent pas';
    if (form.nouveau === form.ancien) return 'Le nouveau mot de passe doit différer de l\'ancien';
    return '';
  };

  const soumettre = async (e) => {
    e.preventDefault();
    const probleme = valider();
    if (probleme) { setErreur(probleme); return; }

    setEnCours(true); setErreur(''); setSucces('');
    try {
      await api.patch('/auth/changer-mot-de-passe', {
        ancien_mot_de_passe: form.ancien,
        nouveau_mot_de_passe: form.nouveau,
      });
      setSucces('Mot de passe modifié.');
      setForm({ ancien: '', nouveau: '', confirmation: '' });
      // Le jeton porte encore l'ancien etat : se reconnecter evite toute
      // incoherence entre le profil en memoire et la base.
      setTimeout(() => { logout(); }, 1500);
    } catch (err) {
      setErreur(err.response?.data?.message || err.message || 'Échec du changement');
    } finally {
      setEnCours(false);
    }
  };

  return (
    <div style={s.page}>
      <form onSubmit={soumettre} style={s.carte}>
        <div style={s.titre}><IconeCle taille={15} /> Changer mon mot de passe</div>

        {impose && (
          <div style={s.avertissement}>
            Votre mot de passe a été réinitialisé par un administrateur.
            Vous devez le changer avant de continuer.
          </div>
        )}

        <label style={s.label}>Mot de passe actuel</label>
        <input type="password" style={s.champ} value={form.ancien}
          onChange={modifier('ancien')} autoComplete="current-password" />

        <label style={s.label}>Nouveau mot de passe</label>
        <input type="password" style={s.champ} value={form.nouveau}
          onChange={modifier('nouveau')} autoComplete="new-password" />
        <div style={s.aide}>{LONGUEUR_MINIMALE} caractères minimum</div>

        <label style={s.label}>Confirmer le nouveau mot de passe</label>
        <input type="password" style={s.champ} value={form.confirmation}
          onChange={modifier('confirmation')} autoComplete="new-password" />

        {erreur && <div style={s.erreur}>{erreur}</div>}
        {succes && <div style={s.succes}>{succes} Reconnexion…</div>}

        <button type="submit" disabled={enCours} style={s.bouton}>
          {enCours ? <><IconeHorloge taille={13} /> Modification…</> : 'Changer mon mot de passe'}
        </button>

        {!impose && (
          <button type="button" onClick={() => navigate(-1)} style={s.retour}>Annuler</button>
        )}
      </form>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', background: '#F4F6F8', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: 'inherit' },
  carte: { width: '100%', maxWidth: 420, background: '#fff', borderRadius: 14, padding: 28, boxShadow: '0 8px 30px rgba(0,0,0,0.08)' },
  titre: { fontSize: 18, fontWeight: 800, color: '#0D1B2A', marginBottom: 18 },
  avertissement: { background: '#FEF9E7', border: '1px solid #F1C40F', borderRadius: 8, padding: '10px 12px', fontSize: 12, color: '#9A7D0A', marginBottom: 16, lineHeight: 1.5 },
  label: { display: 'block', fontSize: 11, fontWeight: 700, color: '#555', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 6, marginTop: 12 },
  champ: { width: '100%', padding: '10px 12px', borderRadius: 8, border: '1.5px solid #E5E7EB', fontSize: 14, fontFamily: 'inherit', boxSizing: 'border-box' },
  aide: { fontSize: 11, color: '#aaa', marginTop: 4 },
  erreur: { background: '#FDEDEC', border: '1px solid #C0392B', color: '#96281B', borderRadius: 8, padding: '9px 12px', fontSize: 12, marginTop: 16 },
  succes: { background: '#EAFAF1', border: '1px solid #27AE60', color: '#1E8449', borderRadius: 8, padding: '9px 12px', fontSize: 12, marginTop: 16 },
  bouton: { width: '100%', padding: '12px', borderRadius: 10, border: 'none', background: '#0D1B2A', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', marginTop: 20 },
  retour: { width: '100%', padding: '9px', borderRadius: 10, border: '1px solid #ddd', background: '#fff', fontSize: 12, cursor: 'pointer', fontFamily: 'inherit', marginTop: 8 },
};
